// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1ZK46","row":"styles_row__1CalQ"};